"use strict";

var _defineProperty = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var react_2 = require("@emotion/react");

var rgba_1 = __importDefault(require("polished/lib/color/rgba"));

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_common_1 = require("@ryerson/frontend.common");

var enums_1 = require("../enums");

var inputStyle_1 = require("./inputStyle");

var polished_1 = require("polished");

var frontend_common_2 = require("@ryerson/frontend.common");

var InputStyling = styled_1.default.input(inputStyle_1.inputStyle);
var TextareaStyling = styled_1.default.textarea(inputStyle_1.inputStyle);
var InputContainer = styled_1.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tborder: 0;\n\tmargin: 0;\n\tpadding: 0;\n\tposition: relative;\n\tmin-width: 0;\n"])));
var ErrorContainer = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tmargin-top: 10px;\n\tmargin-bottom: 8px;\n"])));
var Label = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var fontSize = props.fontSize,
      disabled = props.disabled,
      disableColor = props.disableColor,
      type = props.type,
      theme = props.theme;
  var labelColor = theme.colors[type].label;
  return (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\tfont-size: ", ";\n\t\t\tcolor: ", ";\n\t\t"])), fontSize, disabled ? disableColor : labelColor);
});
var IconContainer = styled_1.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\ttop: 50%;\n\tmargin-top: -10px; // this needs to be computed\n\n\t", "\n\n\t", "\n"])), function (props) {
  var outlineColor = props.outlineColor,
      iconLabel = props.iconLabel,
      outlineSize = props.outlineSize,
      outlinedInputSideSpacing = props.outlinedInputSideSpacing,
      outlinedInputTopSpacing = props.outlinedInputTopSpacing,
      position = props.position;
  return (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t\twidth: ", ";\n\t\t\theight: ", ";\n\t\t\tborder-radius: 50%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tmargin-top: ", ";\n\t\t\t", ": ", ";\n\t\t"])), outlineColor || "transparent", iconLabel ? "fit-content" : outlineSize, outlineSize, outlinedInputTopSpacing, position === "left" ? "left" : "right", outlinedInputSideSpacing);
}, function (props) {
  var clickable = props.clickable;
  return clickable ? (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tspan {\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t}\n\t\t\t  "]))) : "";
});
var LeftIconStyling = (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\theight: 50px;\n\tdisplay: inline-block;\n\tposition: absolute;\n\tmargin-left: -12px;\n"])));
var Input = react_1.default.memo(function (_ref) {
  var _size$sm$size, _size$sm$size2;

  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      id = _ref.id,
      dataTestId = _ref.dataTestId,
      value = _ref.value,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? "square" : _ref$shape,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      label = _ref.label,
      labelAddition = _ref.labelAddition,
      placeholder = _ref.placeholder,
      _ref$inputType = _ref.inputType,
      inputType = _ref$inputType === void 0 ? "text" : _ref$inputType,
      pattern = _ref.pattern,
      maxLength = _ref.maxLength,
      inputRef = _ref.inputRef,
      componentRef = _ref.componentRef,
      name = _ref.name,
      addStyle = _ref.addStyle,
      validation = _ref.validation,
      icon = _ref.icon,
      iconLabel = _ref.iconLabel,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? "right" : _ref$iconPosition,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onKeyUp = _ref.onKeyUp,
      onKeyDown = _ref.onKeyDown,
      onPaste = _ref.onPaste,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? true : _ref$border,
      background = _ref.background,
      _ref$isValid = _ref.isValid,
      isValid = _ref$isValid === void 0 ? true : _ref$isValid,
      _ref$submitted = _ref.submitted,
      submitted = _ref$submitted === void 0 ? true : _ref$submitted,
      onIconClick = _ref.onIconClick,
      iconBackgroundColor = _ref.iconBackgroundColor,
      breakPoint = _ref.breakPoint,
      min = _ref.min,
      max = _ref.max,
      language = _ref.language,
      sizeMobile = _ref.sizeMobile,
      autoComplete = _ref.autoComplete,
      allowedCharacters = _ref.allowedCharacters;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var mobileBreakPoint = breakPoint && "".concat(breakPoint, "px") || theme.breakpoints.lg;

  var _ref3 = (0, frontend_common_2.useWindowSize)(),
      _ref4 = _slicedToArray(_ref3, 1),
      width = _ref4[0];

  sizeMobile && width < parseInt(mobileBreakPoint) && (size = sizeMobile);
  var iconName = icon;
  border = type === "tertiary" ? false : border;

  var _ref5 = (0, react_1.useState)(),
      _ref6 = _slicedToArray(_ref5, 2),
      error = _ref6[0],
      setError = _ref6[1];

  var _ref7 = (0, react_1.useState)(isValid),
      _ref8 = _slicedToArray(_ref7, 2),
      valid = _ref8[0],
      setValid = _ref8[1];

  (0, react_1.useEffect)(function () {
    required && setError((0, frontend_common_2.validateRequired)(value) || (0, frontend_common_2.validatePattern)(value, pattern) || validation && validation(value, language));
    setValid(isValid);
  }, [isValid]);
  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      gray = _theme$colors$primary.gray,
      lighterGray = _theme$colors$primary.lighterGray,
      lightGray = _theme$colors$primary.lightGray,
      errorColor = _theme$colors$primary.error,
      disableColor = _theme$colors$primary.disable,
      focusColor = _theme$colors$primary.primaryBrand;
  var inputPadding = enums_1.InputPadding[size];
  var outlinedInputSideSpacing = enums_1.OutlinedIconInputSidePadding[size];
  var outlinedInputTopSpacing = enums_1.OutlinedIconInputTopPadding[size];
  var borderRadiusSquare = "2px";
  var borderRadiusRound = "42px";
  var borderColor = !valid ? (0, polished_1.mix)(0.4, errorColor, white) : (0, rgba_1.default)(lightGray, 0.8);
  var iconsColor = gray;
  var iconSize = size === "sm" ? "xs" : "sm";
  var borderRadius = shape === "rounded" ? borderRadiusRound : borderRadiusSquare;
  var iconOutlineSize = (_size$sm$size = {}, _defineProperty(_size$sm$size, size, "34px"), _defineProperty(_size$sm$size, "sm", "22px"), _size$sm$size)[size];
  var iconMarginTop = (_size$sm$size2 = {}, _defineProperty(_size$sm$size2, size, "-17px"), _defineProperty(_size$sm$size2, "sm", "-10px"), _size$sm$size2)[size];
  var inputPaddingSize = iconLabel ? iconLabel.length * 10 + 40 + "px" // 8px per letter + margin and icon size
  : iconOutlineSize;
  var isLabelAdditionString = typeof labelAddition === "string";
  var dynamicInputStyle = (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\tborder: ", ";\n\t\t\t", "\n\t\t\tfont-size: ", ";\n\t\t\tbackground-color: ", ";\n\t\t\topacity: 1;\n\t\t\t@media only screen and (max-width: calc( ", " - 1px )) {\n\t\t\t\theight: ", ";\n\t\t\t\tpadding-left: ", ";\n\t\t\t}\n\n\t\t\t@media only screen and (min-width: ", ") {\n\t\t\t\theight: ", ";\n\t\t\t\tpadding-left: ", ";\n\t\t\t}\n\n\t\t\t:focus {\n\t\t\t\tborder: ", ";\n\t\t\t}\n\t\t\t::placeholder {\n\t\t\t\tcolor: ", ";\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t"])), border ? "1px solid ".concat(borderColor) : "0", icon && "padding-".concat(iconPosition, ": ").concat(inputPaddingSize, ";"), size === "sm" ? theme.typography.fonts.sizes.sm.size : theme.typography.fonts.sizes.md.size, disabled ? lighterGray : background ? background : white, mobileBreakPoint, enums_1.InputMobileHeight[size], iconPosition === "left" ? "40px" : enums_1.InputPadding[size], theme.breakpoints.lg, enums_1.InputHeight[size], iconPosition === "left" ? "40px" : enums_1.InputPadding[size], border ? "1px solid ".concat(focusColor) : "0", disabled ? (0, rgba_1.default)(disableColor, 0.8) : lightGray);
  var dynamicTextAreaStyle = (0, react_2.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\tborder: ", ";\n\t\t\tpadding-", ": ", ";\n\t\t\tbackground-color: ", ";\n\t\t\tfont-size: ", ";\n\n\t\t\t:focus {\n\t\t\t\tborder: ", ";\n\t\t\t}\n\n\t\t\t::placeholder {  \n\t\t\t\tcolor: ", ";\n\t\t\t\topacity: 1; \n\t\t\t  } \n\t\t"])), border ? "1px solid ".concat(borderColor) : "0", iconPosition, inputPaddingSize, disabled ? lighterGray : background ? background : white, size === "sm" ? theme.typography.fonts.sizes.sm.size : theme.typography.fonts.sizes.md.size, border ? "1px solid ".concat(focusColor) : "0", disabled ? (0, rgba_1.default)(disableColor, 0.8) : lightGray);
  var iconPadding = (0, react_2.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t\t\tpadding-", ": ", ";\n\t\t"])), iconPosition, inputPadding);
  var iconLabelMargin = (0, react_2.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\tmargin: 0 5px;\n\t\t\tmargin-", ": 0;\n\t\t"])), iconPosition);
  var LabelContainer = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\t\t\tmargin-bottom: ", ";\n\t\t"])), enums_1.LabelBottomMargin[size]);

  var noScroll = function noScroll(event) {
    var activeElement = document === null || document === void 0 ? void 0 : document.activeElement;

    if (activeElement === event.target) {
      event.target.blur();
      window && (window === null || window === void 0 ? void 0 : window.setTimeout(function () {
        event.target.focus();
      }, 10));
    }
  };

  var handlePaste = function handlePaste(event) {
    var _a, _b;

    var pastedText = (_a = event.clipboardData || (window === null || window === void 0 ? void 0 : window.clipboardData)) === null || _a === void 0 ? void 0 : _a.getData("text");

    if (allowedCharacters && pastedText) {
      var re = new RegExp(allowedCharacters, "gi");
      var hasMatch = !!pastedText.match(re);

      if (!hasMatch) {
        event.preventDefault(); // Strip Away Not Allowed Chars

        var strippedText = pastedText.split("").filter(function (itm) {
          return !!itm.match(re) && itm;
        }).join(""); // Set the Value and Trigger and onChange

        var changeEvent = new Event("change", {
          bubbles: true
        });
        var windowProp = window && window.HTMLInputElement.prototype;
        var nativeInputValueSetter = Object && ((_b = Object === null || Object === void 0 ? void 0 : Object.getOwnPropertyDescriptor(windowProp, "value")) === null || _b === void 0 ? void 0 : _b.set);
        nativeInputValueSetter && nativeInputValueSetter.call(event.target, "".concat(strippedText));
        event.target.dispatchEvent(changeEvent);
        return false;
      }
    }

    onPaste && onPaste(event);
  };

  var handleChange = function handleChange(event) {
    onChange(event);
  };

  var handleFocus = function handleFocus(value) {
    onFocus && onFocus(value);
  };

  var handleBlur = function handleBlur(value) {
    // Only trigger onBlur validations if the form has been submitted.
    submitted && validateInput(value);
    onBlur && onBlur(value);
  };

  var handleKeyUp = function handleKeyUp(event) {
    onKeyUp && onKeyUp(event);
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (inputType === "number" && (event.key === "ArrowUp" || event.key === "ArrowDown" || event.key === "Up" || event.key === "Down")) {
      event.preventDefault();
      return false;
    }

    if (!!allowedCharacters) {
      var alwaysAllow = ["Meta", "Backspace", "Control", "Enter", "Tab", "Escape", "Cmd", "Fn", "Shift", "Down", "Up", "Left", "Right", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "End", "Home", "Delete", "Command"];
      var copyPasteKeys = event.metaKey && ["c", "x", "v"].includes(event.key);

      if (!alwaysAllow.includes(event.key) && !copyPasteKeys) {
        var re = new RegExp(allowedCharacters, "gi");
        var hasMatch = !!event.key.match(re);

        if (!hasMatch) {
          event.preventDefault();
          return false;
        }
      }
    }

    onKeyDown && onKeyDown(event);
  };

  var handleIconClick = function handleIconClick(event) {
    onIconClick && onIconClick(event);
  };

  var validAllowedCharacters = function validAllowedCharacters(value) {
    var retVal = true;

    if (allowedCharacters) {
      var result = (0, frontend_common_1.validateAllowedCharacters)(value, allowedCharacters);
      setError(result);
      setValid(!result);
      retVal = !result;
    }

    return retVal;
  };

  var validPattern = function validPattern(value) {
    var retVal = true;

    if (pattern) {
      var result = (0, frontend_common_2.validatePattern)(value, pattern);
      setError(result);
      setValid(!result);
      retVal = !result;
    }

    return retVal;
  };

  var validRequired = function validRequired(value) {
    var retVal = true;

    if (required) {
      var result = (0, frontend_common_2.validateRequired)(value, language);
      setError(result);
      setValid(!result);
      retVal = !result;
    }

    return retVal;
  };

  var validateInput = function validateInput(value) {
    // Following is the order of precedence for validation of the input control
    if (!validRequired(value)) return;
    if (!validPattern(value)) return;
    if (!validAllowedCharacters(value)) return;

    if (validation) {
      var result = validation(value);
      setError(result);
      setValid(!result);
    }
  };

  return (0, jsx_runtime_1.jsxs)("div", {
    className: "input-component-root-".concat(size, " ").concat(className),
    children: [(label || labelAddition) && (0, jsx_runtime_1.jsxs)(LabelContainer, {
      className: "label-container-outer",
      direction: isLabelAdditionString ? "column" : "row",
      alignItems: isLabelAdditionString ? "flex-start" : "center",
      children: [label && (0, jsx_runtime_1.jsxs)(Label, {
        className: "color-label",
        disabled: disabled,
        disableColor: disableColor,
        type: type,
        theme: theme,
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          css: {
            color: "inherit"
          },
          className: "typography-label",
          children: label
        }), required && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          color: errorColor,
          children: " *"
        })]
      }), labelAddition && (isLabelAdditionString ? (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        type: type,
        size: size,
        children: labelAddition
      }) : labelAddition)]
    }), (0, jsx_runtime_1.jsxs)(InputContainer, {
      children: [icon && iconPosition === "left" && (0, jsx_runtime_1.jsxs)(IconContainer, {
        className: "icon-container",
        role: "button",
        position: iconPosition,
        inputPadding: inputPadding,
        iconLabel: iconLabel,
        outlinedInputSideSpacing: outlinedInputSideSpacing,
        outlinedInputTopSpacing: outlinedInputTopSpacing,
        outlineColor: iconBackgroundColor,
        clickable: !!onIconClick,
        onClick: handleIconClick,
        outlineSize: iconOutlineSize,
        marginTop: iconMarginTop,
        children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          icon: iconName,
          size: iconSize,
          color: iconBackgroundColor ? white : iconsColor,
          css: LeftIconStyling
        }), iconLabel && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          css: iconLabelMargin,
          size: "xs",
          variant: "span",
          children: iconLabel
        })]
      }), inputType === "textarea" ? (0, jsx_runtime_1.jsx)(TextareaStyling, {
        style: Object.assign(Object.assign({}, addStyle), {
          color: gray
        }),
        "data-testid": dataTestId,
        placeholder: placeholder,
        maxLength: maxLength,
        value: value,
        onPaste: function onPaste(event) {
          return handlePaste(event);
        },
        onChange: function onChange(event) {
          return handleChange(event);
        },
        onFocus: function onFocus(event) {
          return handleFocus(event.target.value);
        },
        onBlur: function onBlur(event) {
          return handleBlur(event.target.value);
        },
        onKeyUp: function onKeyUp(event) {
          return handleKeyUp(event);
        },
        onKeyDown: function onKeyDown(event) {
          return handleKeyDown(event);
        },
        onWheel: noScroll,
        ref: inputRef,
        name: name,
        disabled: disabled,
        "aria-disabled": disabled ? true : false,
        css: dynamicTextAreaStyle,
        autoComplete: autoComplete
      }) : (0, jsx_runtime_1.jsx)(InputStyling, {
        style: Object.assign(Object.assign({
          borderRadius: borderRadius
        }, addStyle), {
          color: gray,
          MozAppearance: "textfield"
        }),
        id: id,
        "data-testid": dataTestId,
        type: inputType || "text",
        pattern: pattern,
        placeholder: placeholder,
        maxLength: maxLength,
        value: value,
        onPaste: function onPaste(event) {
          return handlePaste(event);
        },
        onChange: function onChange(event) {
          return handleChange(event);
        },
        onFocus: function onFocus(event) {
          return handleFocus(event.target.value);
        },
        onBlur: function onBlur(event) {
          return handleBlur(event.target.value);
        },
        onKeyUp: function onKeyUp(event) {
          return handleKeyUp(event);
        },
        onKeyDown: function onKeyDown(event) {
          return handleKeyDown(event);
        },
        onWheel: inputType === "number" && noScroll || undefined,
        ref: inputRef,
        name: name,
        disabled: disabled,
        "aria-disabled": disabled ? true : false,
        css: dynamicInputStyle || icon && iconPadding,
        min: min,
        max: max,
        autoComplete: autoComplete
      }), icon && iconPosition === "right" && (0, jsx_runtime_1.jsxs)(IconContainer, {
        className: "icon-container",
        role: "button",
        position: iconPosition,
        inputPadding: inputPadding,
        iconLabel: iconLabel,
        outlinedInputSideSpacing: outlinedInputSideSpacing,
        outlinedInputTopSpacing: outlinedInputTopSpacing,
        outlineColor: iconBackgroundColor,
        clickable: !!onIconClick,
        onClick: handleIconClick,
        outlineSize: iconOutlineSize,
        marginTop: iconMarginTop,
        children: [(0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          icon: iconName,
          size: iconSize,
          color: iconBackgroundColor ? white : iconsColor
        }), iconLabel && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          css: iconLabelMargin,
          size: "xs",
          variant: "span",
          children: iconLabel
        })]
      })]
    }), !valid && (0, jsx_runtime_1.jsx)(ErrorContainer, {
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "md",
        color: type !== "tertiary" ? errorColor : (0, polished_1.mix)(0.2, errorColor, white),
        children: error
      })
    })]
  });
}, function (prevProps, nextProps) {
  return prevProps.placeholder === nextProps.placeholder && prevProps.addStyle === nextProps.addStyle && prevProps.value === nextProps.value && prevProps.submitted === nextProps.submitted && prevProps.isValid === nextProps.isValid && prevProps.disabled === nextProps.disabled && prevProps.inputType === nextProps.inputType && prevProps.label === nextProps.label;
});
Input.displayName = "Input";
exports.default = Input;